package io.horion.cv.models

object TestimonialData {

    val testimonials = listOf(

        Testimonial(
            imgSrc = "person1.webp",
            comment = "\"Ce site est très intuitif et m'a permis de créer un CV professionnel en quelques minutes, sans difficulté.\"",
            name = "Carine",
            job = "Etudiante en Informatique",
            star = 4
        ),
        Testimonial(
            imgSrc = "person2.webp",
            comment = "\"Grâce à cette plateforme, j'ai pu concevoir un CV moderne et bien structuré qui met efficacement en valeur mes compétences et mon expérience.\"",
            name = "Laure",
            job = "Chef cuisinier",
            star = 3
        ),
        Testimonial(
            imgSrc = "person3.webp",
            comment = "\"J'apprécie la qualité des modèles proposés ainsi que la simplicité de personnalisation, ce qui rend la création d'un CV rapide et agréable.\"",
            name = "Mauto",
            job = "Technicien en bâtiment",
            star = 3
        )

    )
}